/* eslint-disable quote-props */
/*eslint complexity: off*/
import React, { useEffect } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';

import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { CircularProgress } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import Paper from '~/components/Paper';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputShow from '~/components/InputShow';
import { SusRecordShowForm } from './containers/SusRecordShowForm';

import { URL } from '~/config/uri';
import Request from '~/providers/Request';

function PatientHeader({ usuario }) {
  const nasc =
    usuario && usuario.dataNascimento
      ? moment(usuario.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : '-';
  return (
    <Paper Icon={AssignmentIndIcon} title="Prontuário SUS">
      {usuario && (
        <GridContainer>
          <GridItem xs={12} sm={6} md={5}>
            <InputShow label={'Paciente'} value={usuario.nome || '-'} />
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <InputShow label={'CNS'} value={usuario.cns || '-'} />
          </GridItem>
          <GridItem xs={12} sm={6} md={2}>
            <InputShow label={'CPF'} value={usuario.cpf || '-'} />
          </GridItem>
          <GridItem xs={12} sm={6} md={2}>
            <InputShow label={'Nascimento'} value={nasc} />
          </GridItem>
        </GridContainer>
      )}
    </Paper>
  );
}

function Estratificacoes({ itens }) {
  if (!itens || !itens.length) return null;
  return (
    <Paper Icon={AssignmentIndIcon} title="Estratificações">
      {itens.map((item, key) => (
        <GridContainer key={key} style={{ marginBottom: 8 }}>
          {Object.entries(item || {}).map(([k, v]) => (
            <GridItem key={k} xs={12} sm={6} md={4}>
              <InputShow
                label={k}
                value={
                  v && typeof v === 'object' ? JSON.stringify(v) : String(v)
                }
              />
            </GridItem>
          ))}
        </GridContainer>
      ))}
    </Paper>
  );
}

function SusRecord({ clientCNS }) {
  const [susData, setSusData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [errorMessage, setErrorMessage] = React.useState('');

  useEffect(() => {
    const fn = async () => {
      try {
        const response = await fetch(
          `${URL}/admin/medical_records/cns/${clientCNS}`,
          {
            method: 'GET',
            headers: { Authorization: `Bearer ${await Request.getAuth()}` },
          }
        );
        const data = await response.json();
        if (data && data.message) {
          setErrorMessage(data.message);
        } else {
          setSusData(data);
        }
      } catch (err) {
        toast.error('Erro ao buscar dados do SUS');
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fn();
  }, [clientCNS]);

  const atendimentos = (susData && susData.atendimentos) || [];

  return (
    <>
      <PatientHeader usuario={susData && susData.usuario} />

      {atendimentos.map((at, key) => (
        <SusRecordShowForm key={at.id || key} atendimento={at} />
      ))}

      <Estratificacoes itens={susData && susData.estratificacoes} />

      {!loading && !errorMessage && atendimentos.length === 0 && (
        <Typography style={{ textAlign: 'center', marginTop: 16 }}>
          Nenhum atendimento encontrado no SUS para este paciente.
        </Typography>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 12,
        }}
      >
        {loading && <CircularProgress color={'primary'} />}
        <p>{errorMessage}</p>
      </div>
    </>
  );
}

export default React.memo(SusRecord);
